import {UpdateForm} from './forms/UpdateForm.tsx'
import {Alert, Button, Card, Fieldset, Text, Title} from '@mantine/core'
import {useUserSettings} from '../../providers/userSettings/useUserSettings.ts'
import {useAuth0} from '@auth0/auth0-react'
import {IconCheck} from '@tabler/icons-react'
import {api} from '../../trpc/api.ts'
import {showNotification} from '../../notifications/showNotification.ts'

export const UserSettingsScreen = () => {
  const {user} = useAuth0()
  const {userSettings, loading} = useUserSettings()
  const {
    mutateAsync: sendUpdatePasswordEmail,
    isPending: sendingUpdatePasswordEmail,
    isSuccess: updatePasswordEmailSent,
  } = api.user.sendUpdatePasswordEmail.useMutation(
    showNotification('Email sent successfully', 'Error while sending email'),
  )

  const disabled = loading || sendingUpdatePasswordEmail
  return (
    <div style={{display: 'flex', justifyContent: 'center'}}>
      <div style={{flex: 1, display: 'flex', flexDirection: 'column', gap: 10, maxWidth: 800}}>
        <Title order={3}>Settings</Title>

        <Card>
          <Fieldset legend={'Password'}>
            <Button
              onMouseDown={() => sendUpdatePasswordEmail({})}
              disabled={disabled || !user || updatePasswordEmailSent}
            >
              Change password
            </Button>

            {updatePasswordEmailSent && (
              <Alert variant={'light'} color={'green'} icon={<IconCheck stroke={1} />}>
                <Text size={'sm'}>You should have received an email to reset change your password</Text>
              </Alert>
            )}
          </Fieldset>
          <Fieldset legend={'Calendar'}>
            <UpdateForm userSettings={userSettings} disabled={disabled} />
          </Fieldset>
        </Card>
      </div>
    </div>
  )
}
